<ion-header class="modal-header">
  <div class="modal-title">
    <h3>Add Service Account</h3>
  </div>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button
        fill="clear"
        shape="round"
        class="close-button"
        (click)="dismiss()"
      >
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-card style="margin: 15px">
    <ion-card-content>
      <ion-label class="input-label"> Name </ion-label>
      <ion-input
        placeholder="My service account"
        [(ngModel)]="name"
        class="input-field"
      >
      </ion-input>

      <ion-label class="input-label"> Role </ion-label>
      <ion-select
        placeholder="Role"
        [(ngModel)]="role"
        class="input-field"
        interface="popover"
      >
        <ion-select-option
          *ngFor="let option of ROLE_OPTIONS"
          [value]="option.value"
        >
          <ion-icon *ngIf="option.icon" [name]="option.icon"></ion-icon>
          {{ option.label }}
        </ion-select-option>
      </ion-select>
    </ion-card-content>
  </ion-card>
</ion-content>

<ion-footer class="footer">
  <ion-button (click)="submit()" [disabled]="isLoading">
    Save and generate API key
    <ion-spinner
      name="crescent"
      [hidden]="!isLoading"
      style="margin-left: 10px"
    ></ion-spinner>
  </ion-button>
</ion-footer>
